"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = require("gsap");
const white_circle_png_1 = __importDefault(require("../images/white_circle.png"));
const black_circle_png_1 = __importDefault(require("../images/black_circle.png"));
const face_2_png_1 = __importDefault(require("../images/face_2.png"));
const face_sprite_png_1 = __importDefault(require("../images/face_sprite.png"));
const sink0_png_1 = __importDefault(require("../images/sink0.png"));
const freeze_character_png_1 = __importDefault(require("../images/freeze_character.png"));
const small_png_1 = __importDefault(require("../images/small.png"));
const meet_png_1 = __importDefault(require("../images/meet.png"));
const hug_png_1 = __importDefault(require("../images/hug.png"));
const title_png_1 = __importDefault(require("../images/title.png"));
const txt_concern0_png_1 = __importDefault(require("../images/txt_concern0.png"));
const txt_concern1_png_1 = __importDefault(require("../images/txt_concern1.png"));
const txt_spread_png_1 = __importDefault(require("../images/txt_spread.png"));
const txt_face_png_1 = __importDefault(require("../images/txt_face.png"));
const txt_hole_png_1 = __importDefault(require("../images/txt_hole.png"));
const txt_approach_png_1 = __importDefault(require("../images/txt_approach.png"));
const txt_invade_png_1 = __importDefault(require("../images/txt_invade.png"));
const txt_down_png_1 = __importDefault(require("../images/txt_down.png"));
const txt_stairs_png_1 = __importDefault(require("../images/txt_stairs.png"));
const txt_wave_png_1 = __importDefault(require("../images/txt_wave.png"));
const txt_shallowwater_png_1 = __importDefault(require("../images/txt_shallowwater.png"));
const txt_sink_png_1 = __importDefault(require("../images/txt_sink.png"));
const txt_confetti_png_1 = __importDefault(require("../images/txt_confetti.png"));
const txt_freeze_png_1 = __importDefault(require("../images/txt_freeze.png"));
const txt_walking_png_1 = __importDefault(require("../images/txt_walking.png"));
const txt_direction_png_1 = __importDefault(require("../images/txt_direction.png"));
const txt_despair_png_1 = __importDefault(require("../images/txt_despair.png"));
const txt_door_png_1 = __importDefault(require("../images/txt_door.png"));
const txt_run_png_1 = __importDefault(require("../images/txt_run.png"));
const txt_turn_png_1 = __importDefault(require("../images/txt_turn.png"));
const txt_small_png_1 = __importDefault(require("../images/txt_small.png"));
const txt_meet_png_1 = __importDefault(require("../images/txt_meet.png"));
const txt_hug_png_1 = __importDefault(require("../images/txt_hug.png"));
const logo_white_png_1 = __importDefault(require("../images/logo_white.png"));
const logo_black_png_1 = __importDefault(require("../images/logo_black.png"));
const list = [
    { name: 'whiteCircle', path: white_circle_png_1.default },
    { name: 'blackCircle', path: black_circle_png_1.default },
    { name: 'face2', path: face_2_png_1.default },
    { name: 'faceSprite', path: face_sprite_png_1.default },
    { name: 'sink0', path: sink0_png_1.default },
    { name: 'freezeCharacter', path: freeze_character_png_1.default },
    { name: 'small', path: small_png_1.default },
    { name: 'meet', path: meet_png_1.default },
    { name: 'hug', path: hug_png_1.default },
    { name: 'title', path: title_png_1.default },
    { name: 'textConcern0', path: txt_concern0_png_1.default },
    { name: 'textConcern1', path: txt_concern1_png_1.default },
    { name: 'textSpread', path: txt_spread_png_1.default },
    { name: 'textFace', path: txt_face_png_1.default },
    { name: 'textHole', path: txt_hole_png_1.default },
    { name: 'textApproach', path: txt_approach_png_1.default },
    { name: 'textInvade', path: txt_invade_png_1.default },
    { name: 'textDown', path: txt_down_png_1.default },
    { name: 'textStairs', path: txt_stairs_png_1.default },
    { name: 'textWave', path: txt_wave_png_1.default },
    { name: 'textShallowWater', path: txt_shallowwater_png_1.default },
    { name: 'textSink', path: txt_sink_png_1.default },
    { name: 'textConfetti', path: txt_confetti_png_1.default },
    { name: 'textFreeze', path: txt_freeze_png_1.default },
    { name: 'textWalking', path: txt_walking_png_1.default },
    { name: 'textDirection', path: txt_direction_png_1.default },
    { name: 'textDespair', path: txt_despair_png_1.default },
    { name: 'textDoor', path: txt_door_png_1.default },
    { name: 'textRun', path: txt_run_png_1.default },
    { name: 'textTurn', path: txt_turn_png_1.default },
    { name: 'textSmall', path: txt_small_png_1.default },
    { name: 'textMeet', path: txt_meet_png_1.default },
    { name: 'textHug', path: txt_hug_png_1.default },
    { name: 'logoWhite', path: logo_white_png_1.default },
    { name: 'logoBlack', path: logo_black_png_1.default },
];
class ImageLoader {
    constructor() {
        this.$view = document.querySelector('#loadView');
        this.$count = document.querySelector('#loadCount');
    }
    load(cache) {
        return new Promise(resolve => {
            const total = list.length;
            let count = 0;
            this.setCountView(count, total);
            list.forEach(item => {
                const img = new Image();
                img.crossOrigin = 'anonymous';
                img.addEventListener('load', () => {
                    const texture = this._getTexture(img);
                    cache.add(item.name, texture);
                    count += 1;
                    this.setCountView(count, total);
                    if (count >= total) {
                        gsap_1.gsap.delayedCall(0.1, () => resolve());
                    }
                });
                img.src = item.path;
            });
        });
    }
    hideView() {
        gsap_1.gsap.to(this.$count, { duration: 0.15, opacity: 0 });
        gsap_1.gsap.to(this.$view, {
            duration: 0.3,
            y: -5,
            opacity: 0,
            ease: 'power2.inOut',
            onComplete: () => {
                this.$view && document.body.removeChild(this.$view);
            },
        });
    }
    setCountView(count, total) {
        this.$count.innerText = `${Math.ceil((count / total) * 100)} / ${100}`;
    }
    _getTexture(img) {
        const isJPEG = img.src.search(/\.jpe?g($|\?)/i) > 0 ||
            img.src.search(/^data\:image\/jpeg/) === 0;
        const texture = new THREE.Texture();
        texture.image = img;
        texture.format = isJPEG ? THREE.RGBFormat : THREE.RGBAFormat;
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
        texture.needsUpdate = true;
        return texture;
    }
}
exports.default = ImageLoader;
